import StatusIndicator from '@cloudscape-design/components/status-indicator';

const STATUS_MAP: Record<string, { type: 'success' | 'info' | 'warning' | 'error' | 'stopped'; label: string }> = {
  OPEN: { type: 'info', label: 'Open' },
  IN_PROGRESS: { type: 'in-progress' as any, label: 'In Progress' },
  Pending: { type: 'warning', label: 'Pending' },
  Assigned: { type: 'info', label: 'Assigned' },
  'Work in Progress': { type: 'info', label: 'In Progress' },
  Researching: { type: 'info', label: 'Researching' },
  RESOLVED: { type: 'success', label: 'Resolved' },
  CLOSED: { type: 'stopped', label: 'Closed' },
};

interface Props {
  status: string;
}

export function TicketStatusBadge({ status }: Props) {
  const mapped = STATUS_MAP[status] ?? { type: 'info' as const, label: status };
  return <StatusIndicator type={mapped.type}>{mapped.label}</StatusIndicator>;
}
